export default class ToolbarApi {
  constructor (toolbar) {
    this.toolbar = toolbar
  }

  mount (selector) {
    this.toolbar.$mount(selector)
    return this
  }

  on (event, callback) {
    this.toolbar.$listenSystemEvent(event, callback)
    return this
  }

  off (event, callback) {
    this.toolbar.$ignoreSystemEvent(event, callback)
    return this
  }
}



// WEBPACK FOOTER //
// ./src/api/ToolbarApi.js